const RETURN_STUB = process.env.REACT_APP_STUBS_ENABLED === "true";

export const AssayStub = {
    get: params => {
        if (RETURN_STUB) {
            if (params) {
                if (params.title) {
                    return {
                        data: assays.filter(a => a.title.toLowerCase().includes(params.title.toLowerCase()))
                    }
                }
            }
            return { data: assays }
        }
    }
  }

export const assays = [
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": 20,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 18,
      "last_updated": "12/22/2020 04:12 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 31,
      "title": "SPC",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 13
    },
    {
      "active": true,
      "qa_automated_Checkbox_1600965965": false,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": 15,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 1,
      "last_updated": "12/16/2020 09:03 PM",
      "method": "A",
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": 1,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": 1,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": false,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 6,
      "title": "Amino Acids",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": 30,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 14,
      "last_updated": "06/25/2020 11:51 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Anresco - Pesticides",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 8
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 3,
      "last_updated": "06/09/2020 10:31 PM",
      "method": "C",
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": 1,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Anresco Potency",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 2
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 2,
      "last_updated": "12/16/2020 09:02 PM",
      "method": "B",
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": 1,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Broken HTML",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 1
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 12,
      "last_updated": "12/16/2020 09:03 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Cardio",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 13
    },
    {
      "active": true,
      "qa_automated_Checkbox_1600965965": false,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 34,
      "last_updated": "11/05/2020 07:54 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Coral",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 16
    },
    {
      "active": true,
      "qa_automated_Checkbox_1600965965": false,
      "qa_automated_Hyperlink_1600965971": "hey",
      "qa_automated_TextBoxParagraph_1600965957": "abc",
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 15,
      "last_updated": "12/16/2020 09:03 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": true,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "E. Coli",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 11
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 7,
      "last_updated": "11/05/2020 10:29 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 10,
      "title": "Inject Page Number - Bottom Left",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 8,
      "last_updated": "11/05/2020 10:29 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 11,
      "title": "Inject Page Number - Bottom Middle",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 9,
      "last_updated": "07/08/2020 02:34 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 12,
      "title": "Inject Page Number - Bottom Right",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 4,
      "last_updated": "07/08/2020 02:34 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 7,
      "title": "Inject Page Number - Top Left",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 5,
      "last_updated": "07/08/2020 02:34 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 8,
      "title": "Inject Page Number - Top Middle",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 6,
      "last_updated": "07/08/2020 02:34 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": 9,
      "title": "Inject Page Number - Top Right",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 10,
      "last_updated": "06/15/2020 04:26 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Jinja Borkne",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 5
    },
    {
      "active": true,
      "qa_automated_Checkbox_1600965965": false,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 39,
      "last_updated": "12/15/2020 05:02 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "KeyError (DNU)",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 17
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 17,
      "last_updated": "11/05/2020 10:28 PM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": true,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "Listeria",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": 11
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 20,
      "last_updated": "09/15/2020 02:18 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "QA Automation 09/14/2020 07:18:31 PM",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "qa_automated_Checkbox_1600965965": false,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": 6,
      "id": 21,
      "last_updated": "12/01/2020 05:02 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "QA Automation 09/14/2020 08:07:12 PM",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    },
    {
      "active": true,
      "assay_accessioning_types": null,
      "assay_conditions": null,
      "assay_customer_discounts": null,
      "assay_turnarounds": null,
      "base_price": null,
      "category": null,
      "category_id": null,
      "conditions": null,
      "customer_discounts": null,
      "default_technician": null,
      "default_technician_id": null,
      "default_to_test_config": null,
      "deleted": false,
      "deviations": null,
      "description": "Lorem ipsum dolor sit amet, consec tetur adipiscing elit",
      "duration": null,
      "id": 22,
      "last_updated": "09/15/2020 03:19 AM",
      "method": null,
      "method_detection_limit": null,
      "method_id": null,
      "notes": null,
      "order_report_config": null,
      "order_report_config_id": null,
      "panel_assay_turnarounds": null,
      "panel_assays": null,
      "panels": null,
      "percent_recovery_lower_limit": null,
      "percent_recovery_upper_limit": null,
      "protocol": null,
      "protocol_id": null,
      "relative_percent_difference_limit": null,
      "reporting_limit": null,
      "sample_level_worksheet": false,
      "sample_quantity_type": null,
      "sample_quantity_type_id": null,
      "sample_report_config": null,
      "sample_report_config_id": null,
      "sample_type": null,
      "sample_type_id": null,
      "show_in_portal": true,
      "sort_order": null,
      "specifications": null,
      "spike_level": null,
      "standard_quantity_tested": null,
      "standard_sub_sample": null,
      "sub_category": null,
      "sub_category_id": null,
      "tag": null,
      "tags": null,
      "target": null,
      "target_id": null,
      "team": null,
      "team_id": null,
      "test_report_config": null,
      "test_report_config_id": null,
      "title": "QA Automation 09/14/2020 08:19:21 PM",
      "units": null,
      "worksheet": null,
      "worksheet_ent": null,
      "worksheet_id": null
    }
  ]